import { IContextValues } from '../../../../lib/connect_to_context';
import './styles.css';

export const Loader = ({ widget }: Pick<IContextValues, 'widget'>) => (
  <div className="loader">
    <img
      alt="App is loading..."
      className="loader__indicator"
      width={64}
      height={64}
      src={`${widget.currentOrigin}/cascoon/schedule_loader.svg`}
    />
  </div>
);
